module.exports = __webpack_public_path__ + "img/box-icon2.91fbff4c.svg";